module.exports = __webpack_public_path__ + "img/Icon_Discusion.94f337bb.svg";